module.exports = __webpack_public_path__ + "static/media/winClap.e254a018.mp3";